import {
  React,
  Select,
  Switch,
  Button,
  toast,
  useState,
  Dialog,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  DatePicker,
  DatePanel,
  GetCookie,
  useEffect,
} from "../../../Libraries/Post/GetAllPostRelatedToScreen/ScreenWisePostScheduling/index";

import { useUpdateSidebarSchedulingMutation } from "../../../Redux/service/AllEmpData";

const options = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
];

const SidebarScheduling = (props) => {
  const [updateSidebar] = useUpdateSidebarSchedulingMutation();
  const [data, setData] = useState({
    ser_sidebar_id: null,
    is_scheduled: false,
    daywiseOrDatewise: "",
    selectedDates: [],
    selectedDays: [],
    values: [],
  });
  // useEffect(() => {
  //   if (!props?.schinfo) return;

  //   const dates =
  //     props?.schinfo?.date_wise_scheduled_date &&
  //     props?.schinfo?.date_wise_scheduled_date !== "N/A"
  //       ? props.schinfo.date_wise_scheduled_date.split(",") 
  //       : [];

  //   setData({
  //     ser_sidebar_id: props?.schinfo?.ser_sidebar_id || null,

  //     is_scheduled:
  //       props?.schinfo?.is_scheduled === true ||
  //       props?.schinfo?.is_scheduled === "true" ||
  //       props?.schinfo?.is_scheduled === "t" ||
  //       props?.schinfo?.is_scheduled === 1,

  //     daywiseOrDatewise:
  //       props?.schinfo?.date_wise_or_day_wise !== "N/A"
  //         ? props?.schinfo?.date_wise_or_day_wise
  //         : "",

  //     selectedDates: dates,
  //     values: dates,

  //     selectedDays:
  //       props?.schinfo?.days && props?.schinfo?.days !== "N/A"
  //         ? props?.schinfo?.days.split(",").map((d) => ({
  //             label: d,
  //             value: d,
  //           }))
  //         : [],
  //   });
  // }, [props.schinfo]);

  useEffect(() => {
    if (!props?.schinfo) return;

    const dates =
      props?.schinfo?.date_wise_scheduled_date &&
      props?.schinfo?.date_wise_scheduled_date !== "N/A"
        ? props.schinfo.date_wise_scheduled_date.split(",")
        : [];

    let selectedDays = [];

    if (
      props?.schinfo?.days &&
      props?.schinfo?.days !== "N/A"
    ) {
      if (Array.isArray(props.schinfo.days)) {
        selectedDays = props.schinfo.days;
      } else if (typeof props.schinfo.days === "string") {
        selectedDays = props.schinfo.days.split(",").map((d) => ({
          label: d.trim(),
          value: d.trim(),
        }));
      }
    }

    setData({
      ser_sidebar_id: props?.schinfo?.ser_sidebar_id || null,

      is_scheduled:
        props?.schinfo?.is_scheduled === true ||
        props?.schinfo?.is_scheduled === "true" ||
        props?.schinfo?.is_scheduled === "t" ||
        props?.schinfo?.is_scheduled === 1,

      daywiseOrDatewise:
        props?.schinfo?.date_wise_or_day_wise !== "N/A"
          ? props?.schinfo?.date_wise_or_day_wise
          : "",

      selectedDates: dates,
      values: dates,
      selectedDays,
    });
  }, [props.schinfo]);

  const handleSwitchChange = (e) => {
    setData({ ...data, is_scheduled: e.target.checked });
  };

  const handleScheduleTypeChange = (e) => {
    setData({
      ...data,
      daywiseOrDatewise: e.target.value,
      selectedDays: [],
      selectedDates: [],
      values: [],
    });
  };

  const handleSelectedDaysChange = (e) => {
    setData({ ...data, selectedDays: e });
  };

  const handleSelectedDatesChange = (e) => {
    const dates = e.map((date) => date.format("YYYY-MM-DD"));

    setData({
      ...data,
      selectedDates: dates,
      values: e,
    });
  };

  const handleSubmitSidebarScheduling = async () => {
    try {
      const payload = new FormData();

      payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("ser_screen_id", props.screen);
      payload.append("ser_sidebar_id", data.ser_sidebar_id);

      payload.append("is_scheduled", data.is_scheduled);
      payload.append("date_wise_or_day_wise", data.daywiseOrDatewise || "N/A");

      if (data.daywiseOrDatewise === "Date wise") {
        payload.append(
          "date_wise_scheduled_dates",
          data.selectedDates.join(",") 
        );
        payload.append("days", "N/A");
      }

      if (data.daywiseOrDatewise === "Day wise") {
        payload.append(
          "days",
          data.selectedDays.map((d) => d.value).join(",") 
        );
        payload.append("date_wise_scheduled_dates", "N/A");
      }

      const res = await updateSidebar(payload).unwrap();

      if (res.status === "true") {
        toast.success(res.message);
        props.close();
        props.refreshSidebar?.();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  return (
    <Dialog
      visible={props.show}
      style={{ width: "500px" }}
      modal
      header="Sidebar Scheduling"
      footer={
        <Button variant="contained" onClick={handleSubmitSidebarScheduling}>
          Update
        </Button>
      }
      onHide={props.close}
    >
      <div className="form-group">
        <label>Enable Scheduling</label>
        <Switch checked={data.is_scheduled} onChange={handleSwitchChange} />
      </div>

      {data.is_scheduled && (
        <>
          <FormControl>
            <RadioGroup
              row
              value={data.daywiseOrDatewise}
              onChange={handleScheduleTypeChange}
            >
              <FormControlLabel value="Day wise" control={<Radio />} label="Day wise" />
              <FormControlLabel value="Date wise" control={<Radio />} label="Date wise" />
            </RadioGroup>
          </FormControl>

          {data.daywiseOrDatewise === "Date wise" && (
            <DatePicker
              multiple
              value={data.values}
              onChange={handleSelectedDatesChange}
              plugins={[<DatePanel key="panel" />]}
            />
          )}

          {data.daywiseOrDatewise === "Day wise" && (
            // <Select
            //   isMulti
            //   options={options}
            //   value={data.selectedDays}
            //   onChange={handleSelectedDaysChange}
            // />
           <Select
            isMulti
            options={options}
            value={data.selectedDays}
            onChange={handleSelectedDaysChange}
            menuPlacement="auto"
            menuPosition="fixed"
            menuPortalTarget={document.body}
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "38px",
                height: "auto",
              }),
              valueContainer: (base) => ({
                ...base,
                maxHeight: "none",
                overflow: "visible",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 99999,
              }),
              menu: (base) => ({
                ...base,
                zIndex: 99999,
              }),
            }}
          />
          )}
          
        </>
      )}
    </Dialog>
  );
};

export default SidebarScheduling;